"use strict";
/**
 * Supersede rules for re-run workflow run groups, shared by client and server.
 *
 * A submission can hold several run groups for the same logical case: every re-run appends a
 * new group rather than replacing the old one. The LAST occurrence of a case key is the active
 * run; the earlier ones are superseded ("Prior Cases") and must not be resubmitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.flattenRunGroups = exports.computeSupersededIds = exports.getRunConfigCaseSupersedeKey = exports.getSupersedeCaseKey = void 0;
// Multi-car drafting cases share an attitude-state name across following-car positions, so the
// name alone is not unique. localPosition is stable across re-runs (unlike the following car's
// systemRunId), which makes it the right discriminator.
const followingCarPositionKey = (runGroupCase) => {
    var _a, _b, _c;
    const pos = (_a = runGroupCase === null || runGroupCase === void 0 ? void 0 : runGroupCase.selectedFollowingCar) === null || _a === void 0 ? void 0 : _a.localPosition;
    if (!pos)
        return '';
    return `::x${(_b = pos.distance_x_m) !== null && _b !== void 0 ? _b : 0}::y${(_c = pos.distance_y_m) !== null && _c !== void 0 ? _c : 0}`;
};
/** Stable key grouping all re-runs of one logical case. */
const getSupersedeCaseKey = (wrg) => {
    var _a;
    const caseName = ((_a = wrg.runGroupCase) === null || _a === void 0 ? void 0 : _a.name) || wrg.name;
    return `${caseName}${followingCarPositionKey(wrg.runGroupCase)}`;
};
exports.getSupersedeCaseKey = getSupersedeCaseKey;
/** Same key derived directly from a RunConfigCase (e.g. runConfig.selectedCases). */
const getRunConfigCaseSupersedeKey = (caseItem) => {
    return `${caseItem.name}${followingCarPositionKey(caseItem)}`;
};
exports.getRunConfigCaseSupersedeKey = getRunConfigCaseSupersedeKey;
/**
 * Superseded run-group systemRunIds from a flat list of run groups. Pass every container's run
 * groups (submissionRunGroups[].workflowRunGroups[] flattened) so a re-run landing in a separate
 * "Resubmit Batch" container still retires the run it replaced. The list must stay in
 * chronological order (newest last). 'All' master rows are ignored.
 */
const computeSupersededIds = (runGroups) => {
    const latestByKey = {};
    runGroups.forEach(wrg => {
        if (wrg.name === 'All' || !wrg.systemRunId)
            return;
        latestByKey[(0, exports.getSupersedeCaseKey)(wrg)] = wrg.systemRunId;
    });
    const superseded = new Set();
    runGroups.forEach(wrg => {
        if (wrg.name === 'All' || !wrg.systemRunId)
            return;
        const key = (0, exports.getSupersedeCaseKey)(wrg);
        if (latestByKey[key] && wrg.systemRunId !== latestByKey[key]) {
            superseded.add(wrg.systemRunId);
        }
    });
    return superseded;
};
exports.computeSupersededIds = computeSupersededIds;
/** Flattens a submission's containers into one chronologically ordered run-group list. */
const flattenRunGroups = (submission) => {
    var _a;
    return ((_a = submission === null || submission === void 0 ? void 0 : submission.submissionRunGroups) !== null && _a !== void 0 ? _a : []).flatMap((srg) => { var _a; return (_a = srg === null || srg === void 0 ? void 0 : srg.workflowRunGroups) !== null && _a !== void 0 ? _a : []; });
};
exports.flattenRunGroups = flattenRunGroups;
